import React, { Component } from "react";
import { Icon } from "@iconify/react";
import reactIcon from "@iconify/icons-logos/react";
import mongodb from "@iconify/icons-logos/mongodb";
import nodejs from "@iconify/icons-logos/nodejs"
import expressjs from "@iconify/icons-logos/express"

class About extends Component {
  render() {
    if (this.props.sharedBasicInfo) {
    }
    if (this.props.resumeBasicInfo) {
      var sectionName = this.props.resumeBasicInfo.section_name.about;
      var hello = this.props.resumeBasicInfo.description_header;
      var about = this.props.resumeBasicInfo.description;
    }

    return (
      <section id="about">
        <div className="col-md-12">
          <h1 style={{ color: "black" }}>
            <span>{sectionName}</span>
          </h1>
          {/* <div className="row center mx-auto mb-5">
            <div className="col-md-4 mb-5 center">
              <div className="polaroid">
                <span style={{ cursor: "auto" }}>
                  <img 
                    height="300px"
                    width="250px"
                    // src={profilepic}g
                    src="https://res.cloudinary.com/dbl8uexjf/image/upload/v1718958993/Portfolio/g7jnnozq4u5ukk2k1n5r.jpg"
                    
                    alt="Avatar placeholder"
                  />
                  <Icon
                    icon={nodejs}
                    style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
                  />
                  <Icon
                    icon={reactIcon}
                    style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
                  />
                  <Icon
                    icon={mongodb}
                    style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
                  />
                   <Icon
                    icon={expressjs}
                    style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
                  />
                </span>
              </div>
            </div>

            <div className="col-md-8 center">
              <div className="col-md-10">
                <div className="card">
                  <div className="card-header">
                    <span
                      className="iconify"
                      data-icon="emojione:red-circle"
                      data-inline="false"
                    ></span>{" "}
                    &nbsp;{" "}
                    <span
                      className="iconify"
                      data-icon="twemoji:yellow-circle"
                      data-inline="false"
                    ></span>{" "}
                    &nbsp;{" "}
                    <span
                      className="iconify"
                      data-icon="twemoji:green-circle"
                      data-inline="false"
                    ></span>
                  </div>
                  <div
                    className="card-body font-trebuchet text-justify ml-3 mr-3"
                    style={{
                      height: "auto",
                      fontSize: "132%",
                      lineHeight: "200%",
                    }}
                  >
                    <br />
                    <span className="wave">{hello} :) </span>
                    <br />
                    <br />
                    {about}
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="row center mx-auto mb-5">
  <div className="col-md-4 mb-5 center">
    <div className="polaroid text-center">
      <span style={{ cursor: "auto" }}>
        <img
          height="250px"
          src="https://res.cloudinary.com/dbl8uexjf/image/upload/v1718958993/Portfolio/g7jnnozq4u5ukk2k1n5r.jpg"
          alt="Avatar placeholder"
          style={{ display: "block", margin: "0 auto" }}
        />
        <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
          <Icon
            icon={nodejs}
            style={{ fontSize: "200%", margin: "0 3%" }}
          />
          <Icon
            icon={reactIcon}
            style={{ fontSize: "200%", margin: "0 2%" }}
          />
          <Icon
            icon={mongodb}
            style={{ fontSize: "200%", margin: "0 2%" }}
          />
          <Icon
            icon={expressjs}
            style={{ fontSize: "200%", margin: "0 2%" }}
          />
        </div>
      </span>
    </div>
  </div>

  <div className="col-md-8 center">
    <div className="col-md-10">
      <div className="card">
        <div className="card-header">
          <span
            className="iconify"
            data-icon="emojione:red-circle"
            data-inline="false"
          ></span>{" "}
          &nbsp;{" "}
          <span
            className="iconify"
            data-icon="twemoji:yellow-circle"
            data-inline="false"
          ></span>{" "}
          &nbsp;{" "}
          <span
            className="iconify"
            data-icon="twemoji:green-circle"
            data-inline="false"
          ></span>
        </div>
        <div
          className="card-body font-trebuchet text-justify ml-3 mr-3"
          style={{
            height: "auto",
            fontSize: "132%",
            lineHeight: "200%",
          }}
        >
          <br />
          <span className="wave">{hello} :) </span>
          <br />
          <br />
          {about}
        </div>
      </div>
    </div>
  </div>
</div>

        </div>
      </section>
    );
  }
}

export default About;
